module.exports = __webpack_public_path__ + "static/fonts/Inter_24pt-ExtraBold.995fb5ac.ttf";